import { render } from "./TemplateFrameOptionDisplaySettings.vue?vue&type=template&id=acab09d6&scoped=true"
import script from "./TemplateFrameOptionDisplaySettings.vue?vue&type=script&lang=js"
export * from "./TemplateFrameOptionDisplaySettings.vue?vue&type=script&lang=js"

import "./templateFrameOptionDisplays.scss?vue&type=style&index=0&id=acab09d6&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acab09d6"]])

export default __exports__